import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../App";
import Footer from "../../components/shared/footer/Footer";
import LoaderGif from "../../components/shared/loaderGif/LoaderGif";
import { State } from "../../store";
import { getAlbums, getAllPhotos } from "../../store/actions/user";
import PhotoListItems from "../album/PhotoListItems";
import {
  AlbumName,
  AlbumNameWrapper,
  AlbumPhoto,
  AlbumsHeading,
  AlbumsList,
  AlbumsWrapper,
  AlbumWrapper,
  PhotosHeading,
} from "./AlbumsStyles";

const Albums = () => {
  const isLoading = useSelector((state: State) => state.userReducer.isLoading);
  const albums = useSelector((state: State) => state.userReducer.albums);
  const allPhotos = useSelector((state: State) => state.userReducer.allPhotos);
  const dispatch = useDispatch<AppDispatch>();
  const nav = useNavigate();

  useEffect(() => {
    if (!albums) dispatch(getAlbums());
  }, []);
  useEffect(() => {
    if (!allPhotos) dispatch(getAllPhotos());
  }, []);

  return (
    <div style={{overflow: "hidden"}}>
      <div>
        <LoaderGif isLoading={isLoading} />
        <AlbumsWrapper>
          <AlbumsHeading>Events</AlbumsHeading>
          <AlbumsList>
            {albums &&
              albums?.map((album) => (
                <AlbumWrapper
                  onClick={() => nav(`/album/${album.id}`)}
                  key={album.id}
                >
                  <AlbumPhoto src={album.cover_photo.album_cover} alt="" />
                  <AlbumNameWrapper>
                    <AlbumName>{album.name}</AlbumName>
                  </AlbumNameWrapper>
                </AlbumWrapper>
              ))}
          </AlbumsList>
          <PhotosHeading>All photos</PhotosHeading>
        </AlbumsWrapper>
        <PhotoListItems photos={allPhotos || []} />
        <Footer />
      </div>
    </div>
  );
};

export default Albums;
